export type NativePlatform = 'ios' | 'android' | 'web'
export type NativeEnvelope = {
  version: number
  type: string
  requestId: string
  payload: Record<string, unknown>
}

export type NativeChannel = { postMessage: (value: string) => void }

function channel() {
  return (globalThis as typeof globalThis & { ClashCardsNative?: NativeChannel }).ClashCardsNative
}

export function sendNative(type: string, payload: Record<string, unknown> = {}): string | null {
  const native = channel()
  if (!native) return null
  const requestId = crypto.randomUUID()
  native.postMessage(
    JSON.stringify({ version: 1, type, requestId, payload } satisfies NativeEnvelope),
  )
  return requestId
}

export function hasNativeBridge() {
  return Boolean(channel())
}

type NativeEventTarget = Pick<EventTarget, 'addEventListener' | 'removeEventListener'>

export function waitForNativeResponse(
  requestId: string,
  type: string,
  timeoutMs = 1500,
  eventTarget: NativeEventTarget = globalThis as unknown as NativeEventTarget,
) {
  return new Promise<Record<string, unknown> | null>((resolve) => {
    const listener = (event: Event) => {
      const detail = (event as CustomEvent<NativeEnvelope>).detail
      if (detail.requestId !== requestId || detail.type !== type) return
      globalThis.clearTimeout(timer)
      eventTarget.removeEventListener('clashcards:native', listener)
      resolve(detail.payload)
    }
    const timer = globalThis.setTimeout(() => {
      eventTarget.removeEventListener('clashcards:native', listener)
      resolve(null)
    }, timeoutMs)
    eventTarget.addEventListener('clashcards:native', listener)
  })
}

export function sendNativeAndWait(
  type: string,
  payload: Record<string, unknown>,
  responseType: string,
  timeoutMs = 1500,
  eventTarget: NativeEventTarget = globalThis as unknown as NativeEventTarget,
) {
  const native = channel()
  if (!native) return Promise.resolve<Record<string, unknown> | null>(null)
  const requestId = crypto.randomUUID()
  const response = waitForNativeResponse(requestId, responseType, timeoutMs, eventTarget)
  native.postMessage(
    JSON.stringify({ version: 1, type, requestId, payload } satisfies NativeEnvelope),
  )
  return response
}
